import { type } from "arktype";

export const QuickPayCardDetailSchema = type({
  cardNumber: "string.digits >= 13 & string.digits <= 19",
  cvv: "string.digits >= 3 & string.digits <= 4",
  expiryMonth: "/^(0[1-9]|1[0-2])$/",
  expiryYear: "/^\\d{2,4}$/",
  cardHolderName: "string >= 1 & string <= 100",
});

export const QuickPayCheckDetailSchema = type({
  checkAccountNumber: "string.digits >= 4 & string.digits <= 17",
  routingNumber: "string.digits == 9",
  firstName: "string >= 1 & string <= 50",
  lastName: "string >= 1 & string <= 50",
  checkAccountType: "'Personal' | 'Business'",
  fundingAccountType: "'Checking' | 'Savings'",
});

export const QuickPayAddressSchema = type({
  address1: "string",
  "city?": "string",
  "state?": "string",
  "zip?": "string",
  "country?": "string",
});

const QuickPayBaseFields = type({
  clientRequestId: "string.uuid",
  tenantId: "string >= 1",
  externalId: "string == 12",
  "nameOnAccount?": "string > 1",
  "zipCode?": "string.digits == 5",
  email: "string.email",
  amount: "number > 0",
  "fee?": "number >= 0",
});

const QuickPayCardFields = type({
  requestType: "'card'",
  cardDetail: QuickPayCardDetailSchema,
  "address?": QuickPayAddressSchema,
});

const QuickPayCheckFields = type({
  requestType: "'check'",
  checkDetail: QuickPayCheckDetailSchema,
  address: QuickPayAddressSchema,
});

export const QuickPayInputSchema = type.or(
  QuickPayBaseFields.and(QuickPayCardFields),
  QuickPayBaseFields.and(QuickPayCheckFields),
);

export type QuickPayInput = typeof QuickPayInputSchema.infer;

export const QuickPayOutputSchema = type({
  transactionId: "string",
  statusDescription: "string",
  statusCode: "string",
  transactionDate: "string",
});

export type QuickPayOutput = typeof QuickPayOutputSchema.infer;

export interface QuickPayReceiptContext {
  payerName: string;
  lastFour: string;
  paymentType: "card" | "check";
  accountNumber: string;
  email: string;
}

export const QuickPayStatusInputSchema = type({
  tenantId: "string >= 1",
  externalId: "string == 12",
  clientRequestId: "string.uuid",
});

export type QuickPayStatusInput = typeof QuickPayStatusInputSchema.infer;

export const QuickPayStatusOutputSchema = type({
  "transaction?": QuickPayOutputSchema.and({
    transactionAmount: "number",
  }),
});

export type QuickPayStatusOutput = typeof QuickPayStatusOutputSchema.infer;
